import { ReactNode } from 'react';
import { useToggle } from '@app/hooks';
import styled from 'styled-components';
import Modal from '@app/ui/components/Modal';
import { PublicUserOfferContent } from '@app/pageComponents/PublicUserOfferPage';

type iOfferModal = {
  Component: ReactNode;
  open: () => void;
  close: () => void;
};

const OfferModal = (): iOfferModal => {
  const { state: isOpen, close, open } = useToggle();

  const Component = (
    <StyledModal isOpen={isOpen} onClose={close} withoutHeader>
      <PublicUserOfferContent />

      <ButtonClose onClick={close}>Закрыть</ButtonClose>
    </StyledModal>
  );

  return {
    Component,
    open,
    close,
  };
};

const StyledModal = styled(Modal)`
  && {
    position: relative;
    max-height: none;
    border-radius: 0;
    padding: 0;
    background: unset;
    // height: 100%;

    & > button {
      display: none;
    }
  }
`;

const ButtonClose = styled.button`
  display: block !important;
  position: fixed;
  z-index: 3;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 60px;
  background: #88bcb8;
  color: #fff;
  font-weight: 600;
  text-shadow: 0px 1px 2px #0000004d;
`;

export default OfferModal;
